// extracted by mini-css-extract-plugin
export default {"trigger":"SidePanel__trigger___ojIro","panel":"SidePanel__panel___krJJY","closeButton":"SidePanel__closeButton___oSTg2","icon":"SidePanel__icon___kMol3"};